import { render, staticRenderFns } from "./PopupCodeDocument.vue?vue&type=template&id=64d8b4bb&scoped=true&"
import script from "./PopupCodeDocument.vue?vue&type=script&lang=js&"
export * from "./PopupCodeDocument.vue?vue&type=script&lang=js&"
import style0 from "./PopupCodeDocument.vue?vue&type=style&index=0&id=64d8b4bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8b4bb",
  null
  
)

export default component.exports